export const locale = {
    lang: 'pl',
    data: {
        "Point of sale": "Punkt sprzedaży",
        "Receipt": "Paragon",
        "Invoice": "Faktura",
        "Total": "Razem",
        "Payment method": "Metoda płatności",
        "Customer": "Klient",
        "Print bill": "Drukuj rachunek",
        'Split payment': 'Podzielna płatność',
        "Before discount": "Przed rabatem",
        "Open bill": "Otwarty rachunek",
        "Save bill": "Zapisz rachunek",
        "Items": "Pozycje",
        "Created by": "Utworzył",
        "Created at": "Data",
        "PAY": "ZAPŁAĆ",
        'Saving': 'Zapisywanie',
        'All Vouchers': 'Wszystkie karnety'
    }
};
